import {
  ApplicationConfig,
  LOCALE_ID,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { IxNgToastService } from 'ix-ng-forms';
import { IxHttpActivity, IxHttpActivityService } from 'ix-ng-http';
import { ConfirmationService, MessageService } from 'primeng/api';
import { IxNgCacheService, IxNgRoutingService } from 'ix-ng-routing';
import {
  IxKeyValueLookupService,
  IxNgLocalStorageService,
  IxUiHeightServiceImpl,
  IxUrlSerializer,
} from 'ix-ng-components';
import { DialogService } from 'primeng/dynamicdialog';
import { providePrimeNG } from 'primeng/config';
import { arsktrpTheme } from '../../assets/theme/arsktrp/themes/mdp/theme';
import { IxUiHeightService } from 'ix-ng-core';
import { UrlSerializer } from '@angular/router';
import { LocalStorageService } from 'vpo-shared';

export const sharedConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideBrowserGlobalErrorListeners(),
    provideAnimationsAsync(),
    providePrimeNG({
      ripple: true,
      inputStyle: 'filled',
      theme: {
        preset: arsktrpTheme,
        options: { darkModeSelector: '.app-dark' },
      },
    }),
    {
      provide: IxUiHeightService,
      useClass: IxUiHeightServiceImpl,
    },
    IxNgRoutingService,
    { provide: IxHttpActivity, useClass: IxHttpActivityService },
    { provide: UrlSerializer, useClass: IxUrlSerializer },
    { provide: IxNgLocalStorageService, useClass: LocalStorageService },
    IxNgToastService,
    IxHttpActivityService,
    MessageService,
    IxNgCacheService,
    IxKeyValueLookupService,
    {
      provide: LOCALE_ID,
      useValue: 'sl',
    },
    ConfirmationService,
    DialogService,
  ],
};
